import React, { useRef } from "react";
import { useField, Field } from "formik";
import { AppSelectOption } from "fer-react-components";
import AppDropdownCheckbox, { AppDropdownCheckboxProps } from "src/commun/composants/formulaire/AppDropdownCheckbox/AppDropdownCheckbox";

export type AppCheckboFormikProps = Omit<AppDropdownCheckboxProps, "onChange" | "checked"> & {
  options: AppSelectOption[];
};

const AppDropdownCheckboxFormik = ({ name, ...reste }: AppCheckboFormikProps) => {
  const [, { value, error }, { setValue, setTouched }] = useField(name);

  const ref = useRef(undefined);

  const handleCheckboxChange = (option: AppSelectOption) => {
    setTouched(true);
    const newValue = value.map((val: AppSelectOption) => val.value).includes(option.value)
      ? value.filter((val: AppSelectOption) => val.value !== option.value)
      : [...value, option];
    setValue(newValue);
  };

  return (
    <Field
      name={name}
      fieldRef={ref}
      error={error}
      onChange={handleCheckboxChange}
      checked={value}
      as={AppDropdownCheckbox}
      {...reste} />
  )
};

export default AppDropdownCheckboxFormik;
